/**
 * The only component that touches a logo file.
 *
 * Space is reserved from brand.logoAspect, so dropping in a logo with a
 * different aspect ratio at cutover causes zero layout shift. If the asset is
 * missing (for example, the SuprAI suite before it is delivered) the component
 * renders a dignified typographic lockup rather than a broken image.
 */
import React, { useState } from 'react';
import brand from '../brand/brand';

export default function BrandLogo({
  variant = 'light',
  height = 40,
  brandOverride,
  className = '',
  decorative = false,
}) {
  const b = brandOverride || brand;
  const [failed, setFailed] = useState(false);
  const src = variant === 'reversed' ? b.logoReversed : b.logo;
  const width = Math.round(height * (b.logoAspect || 1.5));

  if (failed || !src) {
    return (
      <span
        className={`t-logotype ${className}`}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          height,
          minWidth: width,
          fontSize: Math.round(height * 0.42),
          letterSpacing: '-0.01em',
          whiteSpace: 'nowrap',
          color: variant === 'reversed' ? '#FFFFFF' : 'var(--navy)',
        }}
      >
        {b.legalName}
      </span>
    );
  }

  return (
    <img
      src={src}
      alt={decorative ? '' : `${b.legalName} logo`}
      aria-hidden={decorative ? 'true' : undefined}
      width={width}
      height={height}
      className={className}
      /* Explicit width, not `auto`: inside a shrink-to-fit flex parent the base
         `img { max-width: 100% }` rule can resolve the logo to zero width. */
      style={{ height, width, maxWidth: 'none', flex: 'none', display: 'block' }}
      onError={() => setFailed(true)}
    />
  );
}
